import { FILESPACE_V9 } from '#common/types';
import { OptionalBoolean } from '#config/types';
import { DataStoresNotConfiguredError, DataStoresNotSupportedError, ExternalFilesDisabledError, ExternalFilesNotConfiguredError, ExternalFilesNotSupportedError, } from './types';
export const MIN_EXTERNAL_FILES_FS_VERSION = FILESPACE_V9;
export const MIN_DATA_STORES_FS_VERSION = MIN_EXTERNAL_FILES_FS_VERSION;
export class ExternalFilesConfigValidator {
    settingsCache;
    constructor(settingsCache) {
        this.settingsCache = settingsCache;
    }
    async verifyDataStoresAvailable() {
        const fsVersion = await this.settingsCache.getFsVersion();
        if (fsVersion < MIN_DATA_STORES_FS_VERSION) {
            throw new DataStoresNotSupportedError(`Data stores are not supported on filespace version V${fsVersion}. ` +
                `Minimum required version is V${MIN_DATA_STORES_FS_VERSION}.`);
        }
        const externalFilesEnabled = await this.settingsCache.getExternalFilesEnabled();
        if (externalFilesEnabled === OptionalBoolean.UNSET) {
            throw new DataStoresNotConfiguredError('Data stores cannot be managed when external files feature is not configured.');
        }
    }
    async verifyExternalFilesEnabled() {
        const fsVersion = await this.settingsCache.getFsVersion();
        if (fsVersion < MIN_EXTERNAL_FILES_FS_VERSION) {
            throw new ExternalFilesNotSupportedError(`External files are not supported on filespace version V${fsVersion}. ` +
                `Minimum required version is V${MIN_EXTERNAL_FILES_FS_VERSION}.`);
        }
        const isEnabled = await this.settingsCache.getExternalFilesEnabled();
        if (isEnabled === OptionalBoolean.UNSET) {
            throw new ExternalFilesNotConfiguredError('External files feature is not configured for this filespace.');
        }
        if (isEnabled === OptionalBoolean.FALSE) {
            throw new ExternalFilesDisabledError('External files are disabled for this filespace.');
        }
    }
}
